import React from "react";
import PropTypes from "prop-types";

import { clx } from "../../../../../utils/Helpers";

/** Label on one side, value on the other (Event Summary / Bank Transfer Details). */
const SummaryRow = ({ label, value, total, children }) => (
  <div
    className={clx("publish-pay-step__row", {
      "publish-pay-step__row--total": total,
    })}
  >
    <span className="text-body-sm publish-pay-step__row-label">{label}</span>
    <span
      className={clx(
        "publish-pay-step__row-value",
        total ? "text-label-lg" : "text-label-sm",
      )}
    >
      {children ?? value ?? "—"}
    </span>
  </div>
);

SummaryRow.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  /** Separated by a divider and highlighted (Total Amount Due). */
  total: PropTypes.bool,
  children: PropTypes.node,
};

SummaryRow.defaultProps = {
  value: null,
  total: false,
  children: null,
};

export default SummaryRow;
